import { useEffect, useRef } from 'react'
import { useHeartbeat } from '@/shared/api/telemetry'
// Presence heartbeat — ping on mount and every 30s while the tab is visible,
// so the admin Usage view can show who's online + derive sessions. Skipped
// while hidden so a backgrounded tab doesn't count as "online".
export function usePresenceHeartbeat(): void {
  const heartbeat = useHeartbeat()
  const heartbeatRef = useRef(heartbeat)
  heartbeatRef.current = heartbeat
  useEffect(() => {
    const ping = () => {
      if (document.visibilityState === 'visible') heartbeatRef.current.mutate()
    }
    ping()
    const id = window.setInterval(ping, 30_000)
    document.addEventListener('visibilitychange', ping)
    return () => {
      window.clearInterval(id)
      document.removeEventListener('visibilitychange', ping)
    }
  }, [])
}
